export default __webpack_public_path__ + "static/media/Telegram - Icon.7654a6a2.svg";